import Vue from 'vue';
import DialogStateMixin from '@/helpers/vue_mixins/v2/DialogStateMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import ActionButton from '@/components/action_button/Index.vue';
import AppLatestBilling from '@/plugins/graphql/queries/v2/app-latest-billing.gql';
import '@/assets/stylesheets/v2/_deactivation_notice.scss';
import { BillingBasicModel } from '@/helpers/entities/models/BillingBasicModel';
import { mapGetters, mapMutations } from 'vuex';
export default Vue.extend({
    apollo: {
        billing: {
            query: AppLatestBilling,
            variables() {
                return {
                    appUuid: this.appUUID,
                };
            },
            update({ appLatestBilling }) {
                return new BillingBasicModel(appLatestBilling);
            },
        },
    },
    components: {
        BaseSubtitle,
        ActionButton,
    },
    mixins: [DialogStateMixin, RouterParamsAppMixin],
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            billing: null,
        };
    },
    computed: {
        ...mapGetters(['lastDayGracePeriodReminder']),
    },
    watch: {
        lastDayGracePeriodReminder(val) {
            if (val) {
                const self = this;
                self.hideDialog();
                self.lastDayGracePeriodReminderDialog(false);
            }
        },
    },
    created() {
        this.toggle = this.show;
    },
    methods: {
        ...mapMutations(['lastDayGracePeriodReminderDialog']),
        goToBillDetails() {
            this.$router.push({
                name: 'billing-details',
                params: { uuid: this.billing.uuid },
            });
            this.hideDialog();
        },
        toCurrency(value) {
            return `₱ ${value.toFixed(2)}`;
        },
    },
    render(createElement) {
        const self = this;
        const cardContent = () => {
            return createElement('v-card', { class: 'card pa-4' }, [
                createElement('v-btn', { props: { icon: true }, class: 'close', on: { click: self.hideDialog } }, [createElement('v-icon', ['close'])]),
                createElement('v-layout', { class: 'column align-center justify-center' }, [
                    createElement('v-flex', { class: 'shrink mt-5 mb-4 image-container' }, [
                        createElement('v-img', {
                            class: 'image',
                            props: {
                                src: require('@/assets/images/grace_period.svg'),
                            },
                        }),
                    ]),
                    createElement('v-flex', { class: 'mb-4' }, [
                        createElement('base-subtitle', {
                            props: {
                                text: '24 Hours Left Before Deactivation',
                            },
                        }),
                    ]),
                    createElement('v-flex', { props: { fontSize14: true } }, [
                        createElement('base-text', {
                            props: {
                                text: 'Please note that you have 24 hours left before your In-App Store account is deactivated.' +
                                    ' Please settle your outstanding balance to prevent deactivation of account.',
                            },
                            class: 'text-xs-center',
                        }),
                    ]),
                    createElement('v-flex', { props: { fontSize14: true }, class: 'my-5' }, [
                        createElement('base-text', {
                            props: {
                                text: `Total Balance: ${self.toCurrency(self.billing.accumulatedAmount)}`,
                            },
                        }),
                    ]),
                    createElement('v-flex', { class: 'mb-3' }, [
                        createElement('v-layout', [
                            createElement('v-flex', [
                                createElement('action-button', {
                                    props: { orangeTheme: true, submit: true },
                                    on: { wasClicked: self.goToBillDetails },
                                    attrs: { id: 'viewBill' },
                                }, ['Pay Now']),
                            ]),
                        ]),
                    ]),
                ]),
            ]);
        };
        const loader = () => {
            return createElement('v-card', { class: 'card pa-4' }, [createElement('base-inner-loader')]);
        };
        const content = () => (this.billing ? cardContent() : loader());
        return createElement('v-dialog', {
            props: {
                value: self.toggle,
                width: 400,
                persistent: true,
                contentClass: 'deactivation-notice',
            },
        }, [content()]);
    },
});
